export default ({ app: { router }, store, $ga }, inject) => {
  // 相应的统计文件在nuxt.config.js 里引用
  router.afterEach((to, from) => {
    try {
      if (to.path === from.path) return
      // 百度统计
      window._hmt = window._hmt || []
      window._hmt.push(['_trackPageview', to.fullPath])

      // 友盟cnzz统计
      // window._czc = window._czc || []
      // window._czc.push(['_trackPageview', to.fullPath])

      // 谷歌统计
      window.dataLayer = window.dataLayer || []
      if (typeof window.gtag !== 'function') {
        window.gtag = function () {
          dataLayer.push(arguments)
        }
      }
      window.gtag('js', new Date())
      window.gtag('config', 'G-262WP6CVKR')

      window.gtag('event', 'page_view', {
        page_title: to.meta.pageTitle || document.title,
        page_location: window.location.href,
        page_path: to.path
      })
    } catch (e) {}
  })

  // event: string, params: object
  const buryEvent = (event, params) => {
    console.log('buryEvent,params: ', params)

    if (Object.prototype.toString.call(params) !== '[object Object]') {
      // 传的参数不是对象，给报错
      console.error('事件参数错误')
    }
    //  google analytics
    window.gtag('event', event, { ...params })
    // 百度统计
    window._hmt.push(['_trackEvent', event, ...Object.values(params)])
    // 友盟统计
    // window._czc.push(['_trackEvent', event, JSON.stringify(params)])
  }
  // 将事件埋点方法注入this；通过 this.$xxx 调用

  inject('buryEvent', buryEvent)
}
